import { Form, Link } from 'react-router';
import { Button, TransparentAndeLogo } from '@dinewise/components';
import { $path } from 'safe-routes';

type LoginScreenProps = {
  destination: string | null;
  termsUrl: string;
};

const LoginScreen = ({ destination, termsUrl }: LoginScreenProps) => {
  return (
    <div className="flex min-h-screen flex-1 bg-gradient-to-b from-[#F9F5EF] to-white">
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col px-6 pb-10 pt-20">
        <div className="mb-8 flex flex-col items-center text-center">
          <TransparentAndeLogo color="black" className="size-12" />
          <h1 className="mt-3 font-bold text-2xl text-ande-black">Welcome to Ande</h1>
          <p className="mt-1 text-ande-gray-500 text-sm">
            Login to access Ande&apos;s optimized mobile experience for managing payments
          </p>
        </div>

        <Form method="get" action={$path('/login')} className="flex flex-col">
          {destination ? <input type="hidden" name="destination" value={destination} /> : null}
          <Button type="submit" theme="primary" size="lg" className="mt-6 w-full rounded-xl py-4">
            Login
          </Button>
        </Form>

        <p className="mt-12 text-center text-ande-gray-300 text-xs">
          By logging in, you agree to the{' '}
          <Link to={termsUrl} className="underline" target="_blank" rel="noreferrer">
            Ande Terms of Service
          </Link>
          .
        </p>
      </div>
    </div>
  );
};

export default LoginScreen;
